<template>
    <v-card id="list">
      <v-container fluid>
        <v-row>
            <v-col cols="2">
                <salesman-combo
                    v-model="salesman"
                    label="業務員姓名">
                </salesman-combo>
            </v-col>
            <v-col cols="2">
                <v-text-field v-model="holderName" label="請輸入客戶姓名"></v-text-field>
            </v-col>
            <v-col cols="2" >
                <v-select
                    v-model="level"
                    :items="level_items"
                    label="請選擇客戶等級"
                    clearable
                ></v-select>
            </v-col>
            <v-col cols="2">
                <city-select v-model="selectCity" :options="cities" :labelName="cityLabelName"/>
            </v-col>
            <v-col cols="2">
                <city-select v-model="selectTownship" :options="townships" :labelName="townshipLabelName"/>
            </v-col>
            <v-col cols="2">
                <v-select
                    :items="months"
                    label="請選擇生日月份"
                    v-model="selectedMonth"
                    clearable
                ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn color="primary" class="mr-2" @click="onSearchClick">查詢客戶資料</v-btn>
                <!-- <v-btn color="primary" class="mr-2" @click="onExportClick('excel')">下載客戶名單</v-btn> -->
                <v-btn color="primary" class="mr-2" @click="onExportBirthdayClick('excel')" :disabled = "disableBirthdayButten" >列印當月生日名單</v-btn>
                <v-dialog
                    v-model="dialogSendMessageSetting"
                    width=800>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">發送訊息到手機</v-btn>
                    </template>
                    <send-message @ChangeDialogShowSettingEvent="ChangeDialogSendMesageSetting"></send-message>
                </v-dialog>
                
            </v-col>
        </v-row>
        <v-row>
            <v-col col="12" sm="12">
                <v-card class="mx-auto" tile>
                    <v-card-title>客戶資料列表
                        <v-spacer></v-spacer>
                        <v-dialog 
                            v-model="dialogShowExcelExportSetting"
                            width=500>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" class="mr-2">
                                    匯出Excel
                                </v-btn>
                            </template>
                            <excel-column-setting @ChangeDialogShowSettingEvent="ChangeDialogExportSetting" :exportLoading="exportLoading"></excel-column-setting>
                        </v-dialog>
                        <v-dialog 
                            v-model="dialogShowSetting"
                            width=500>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on">
                                    設定列表欄位
                                </v-btn>
                            </template>
                            <list-header-setting @ChangeDialogShowSettingEvent="ChangeDialogShowSetting"></list-header-setting>
                        </v-dialog>
                    </v-card-title>
                    <v-data-table
                        :headers="getSelectedHolderListHeaders"
                        :items="holders"
                        :page.sync="pagination.current"
                        :items-per-page="pagination.itemsPerPage"
                        disable-pagination
                        :hide-default-footer="true"
                    >
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon large @click="editHolderData(item.id)">mdi-pencil</v-icon>
                        </template>
                    </v-data-table>
                    <v-pagination v-model="pagination.current" :length="pagination.total" @input="onPageChange"></v-pagination>
                </v-card>
            </v-col>
        </v-row>
        <p class="mt-3">{{ message }}</p>
      </v-container>
  </v-card>
</template>
<script>
import CitySelect from '../../components/CitySelect';
import citydata from '../../services/citiesdata.json';
import ListHeaderSetting from './ListHeaderSetting'
import ExcelColumnSetting from './ExcelColumnSetting'
import SendMessage from './SendMessage'
import HolderService from '../../services/HolderService';
import SalesmanCombo from '../../components/SalesmanCombo'
import {mapGetters} from 'vuex';

export default {
    name: "holder-list",
    components: {
        CitySelect,
        SalesmanCombo,
        ListHeaderSetting,
        ExcelColumnSetting,
        SendMessage,
    },
    data(){
       return{
            months:['1','2','3','4','5','6','7','8','9','10','11','12'],
            disableBirthdayButten:true,
            selectedMonth:null,
            holders: [], //列表資料
            level: '', //保單查詢欄位值
            salesman:null, //保單查詢欄位值
            level_items: ['A','B','C','D'],
            message: "",
            pagination: {
                current: 1,
                total: 0,
                itemsPerPage: 20
            },
            selectCity: '',
            selectTownship: '',
            cityLabelName: "請輸入城市(聯絡地址)",
            townshipLabelName: "請輸入區域/鄉鎮(聯絡地址)",
            cityIdx: 0, //城市選擇
            townshipIdx: 0,
            holderName: '',
            dialogShowSetting: false, //控制顯示「設定列表欄位」對話框
            dialogShowExcelExportSetting: false, //控制顯示「匯出Excel」對話框
            dialogSendMessageSetting:false,   //控制顯示「發送訊息到手機」對話框
            exportLoading:false, //控制顯示「匯出Excel」對話框內的Loading動畫顯示效果
        };
    },
    methods: {
        onExportBirthdayClick(type){
            HolderService.exportBirthdayList(type, this.levelName, this.salesmanName, this.selectCity, this.selectTownship, this.selectedMonth)
        },
        onExportClick(type){
            HolderService.exportConnection(type, this.levelName, this.salesmanName, this.selectCity, this.selectTownship);
        },
        onSearchClick(){
            this.pagination.current = 1;
            this.searchHolder();
        },
        onPageChange(){
            //console.log(this.pagination.current,'onPageChange')
            this.searchHolder();
        },
        searchHolder(){
            HolderService.findByCondition(this.levelName, this.salesmanName, 
                                            this.selectCity, this.selectTownship, 
                                            this.holderName,
                                            this.pagination.current, this.pagination.itemsPerPage).then((response) =>{
                    //console.log(response,'HolderList.vue')
                    this.message = response.message;
                    this.holders = response.list.map(this.getDisplayHolder); 
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.pagination.itemsPerPage = parseInt(response.per_page);                  
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getDisplayHolder(holder){
            //console.log(holder)
            return {
                id: holder.id,
                holder_name: holder.name,
                sex: (holder.sex == 'female')? '女' : '男',
                birthday: holder.birthday,
                level: holder.level,
                insurance_address: `${holder.city}${holder.township}${holder.address}`,
                phone: holder.phone,
                email: holder.email,
                connection_address: `${holder.connection_city}${holder.connection_township}${holder.connection_address}`,
                eng_name: holder.eng_name,
                salesman_name: (holder.salesman_id!=null) ? holder.salesman.name : ''
            };
        },
        editHolderData(id){
            let routeData = this.$router.resolve({name: 'holder-detail', params: {id: id}});
            window.open(routeData.href, '_holder-detail-' + id);
        },
        //關閉顯示欄位對話框
        ChangeDialogShowSetting(value){
            this.dialogShowSetting = value
        },
        //關閉Excel匯出對話框
        ChangeDialogExportSetting(value){
            var exportColumns = this.getSelectHolderExportColumns
            HolderService.exportConnection('excel', this.levelName, this.salesmanName, this.selectCity, this.selectTownship, exportColumns)
                .then(
                    //完成下載後才關閉對話框
                    () => {
                        this.dialogShowExcelExportSetting = value
                        this.exportLoading = false
                    }
                );
            
        },
        //關閉發送訊息到手機對話框
        ChangeDialogSendMesageSetting(value){
            this.dialogSendMessageSetting = value
        },

    },
    mounted(){
        this.searchHolder();
    },
    computed:{
        cities: function(){
            return citydata;
        },
        townships: function() {
            if (this.cityIdx == -1) return [];
            return this.cities[this.cityIdx].areas;
        },
        salesmanName(){
            if (this.salesman===null) return ''
            return this.salesman.name
        },
        levelName(){
            if (this.level===null) return ''
            return this.level
        },
        ...mapGetters('holderlist',[
            'getSelectedHolderListHeaders',
        ]),
        ...mapGetters('holderexport',[
            'getSelectHolderExportColumns',
        ]),
    },
    watch: {
        selectCity: function() {
            this.townshipIdx = -1;
            if (this.selectCity == null) {
                this.cityIdx = -1;
                this.selectTownship = '';
            } else {
                var filter = (element) => element.name === this.selectCity;
                this.cityIdx = this.cities.findIndex(filter);
            }
        },  
        selectedMonth: function(){
            this.disableBirthdayButten = (this.selectedMonth =='' || this.selectedMonth===null)
        }
    }
}
</script>
<style scoped>

</style>